export default __webpack_public_path__ + "static/icon-17-4-0259d149b3c9bc216aa4aa3047300b66.png";